import React from 'react'
import styled from 'react-emotion'
import { PageContainer, PageHelmet } from 'components/Page'
import Hero from 'components/Hero'
import Wrapper from 'components/Wrapper'
import Benefits from 'components/Benefits'

const WhyChouxboxPage = ({ data }) => (
  <PageContainer>
    <PageHelmet name="whyChouxbox" />
    <Hero heroImage={data.heroImage} title="Why Chouxbox?" />
    <Benefits benefits={data.benefits} />
  </PageContainer>
)

export default WhyChouxboxPage

export const query = graphql`
  query WhyChouxboxQuery {
    heroImage: imageSharp(id: { regex: "/hero/why-chouxbox.jpg/" }) {
      sizes(maxWidth: 1920) {
        ...GatsbyImageSharpSizes
      }
    }
    benefits: allBenefitsYaml {
      edges {
        node {
          title
          checklist
          quote {
            content
            citation
          }
          background {
            childImageSharp {
              sizes(maxWidth: 1920) {
                ...GatsbyImageSharpSizes
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/why-chouxbox.js